// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZNIE","col":"styles_col__1a4oj"};